import React from 'react'
import { withIcon } from '../../withIcon'

function PlayOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 21 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.70455 6.18836V17.8116L15.4198 12L4.70455 6.18836ZM17.5416 12.7551L4.39655 19.8846C4.25532 19.9603 4.09548 20.0001 3.93286 20C3.77025 19.9999 3.61049 19.9598 3.4694 19.8839C3.3283 19.8079 3.21077 19.6986 3.12844 19.5669C3.04611 19.4351 3.00184 19.2854 3 19.1327V4.86733C3.00184 4.71455 3.04611 4.56488 3.12844 4.43312C3.21077 4.30136 3.3283 4.19209 3.4694 4.11612C3.61049 4.04015 3.77025 4.00013 3.93286 4C4.09548 3.99987 4.25532 4.03965 4.39655 4.1154L17.5416 11.2449C17.6813 11.3225 17.797 11.433 17.8774 11.5654C17.9577 11.6978 18 11.8476 18 12C18 12.1524 17.9577 12.3022 17.8774 12.4346C17.797 12.567 17.6813 12.6775 17.5416 12.7551Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlayOutlineIcon)
